export default __webpack_public_path__ + "static/media/plusPrimary.d583dbf7.svg";